module.exports = {
  // user data tables
  USER: "user",
  CUSTOMER_ADDRESS: "customer_address",
  ADVANCE_CUSTOMER_CONFIGURATION: "advanced_customer_configuration",
  DIMENSION: "dimension",
  DOMESTIC: "domestic",
  INTERNATIONAL: "international",
  MISCELLANEOUS_CONFIGURATION: "miscellaneous_configurations",
  PERMITTED_IP_ADDRESS: "permitted_ip_address",
  PREFS_COLLECTION_DEFAULTS: "prefs_collection_defaults",
  PREFS_CONFIG_SETTINGS: "prefs_config_settings",
  PREFS_INVOICE_SETTINGS: "prefs_invoice_settings",
  RETURN_ADDRESS: "return_address",
  SECURITY_SETTINGS: "security_settings",
  SERVICE_RESTRICTED: "service_restricted",
  SERVICE_XREF_MAPPINGS: "service_xref_mappings",
  SHIPPING_DEFAULTS: "shipping_defaults",
  SHIPPING_SETTINGS: "shipping_settings",
  // customer tables
  PERMITTED_IP: "permitted_ip",
  CUSTOMER: "customer",
  //
  API_USERS: "api_users",
  PROFILE: "profile",
  SEQUENCES: "sequences",
};
